import store from '@/store';

export default {
  created() {
    if (this.$flagsmith && store.getters.isAuthorized) {
      this.$flagsmith.identify(store.getters.myProfile.login);
    }
  },
};
